import React from "react";
import { Switch, Route, Redirect } from 'react-router-dom';

import { Pages } from "components/pages";
import { useMe } from "components/use-hooks";
import checkUser from "utils/check-user";
import UserHelpers from "components/user/helpers";
import { canManageCheckInPoint } from "components/staff-management/helpers/staff-management-permission-helper";

const { permission } = UserHelpers;
const { More } = Pages;
const { canUseAttendance, getUserPermissions } = checkUser;

const MoreRoutes = () => {
    const { me } = useMe();
    const { isLimitedUser } = getUserPermissions(me);

    if (isLimitedUser) {
        return (
            <Switch>
                <Route path="/more/" exact>
                    <More.Single />
                </Route>
                <Route path="/more/collect-graphics" exact>
                    <More.CollectGraphics />
                </Route>
                <Route path="/more/check-in-point" exact>
                    {canManageCheckInPoint(me) ? <More.CheckInPoint /> : <Redirect to="/more" />}
                </Route>
                <Route path="/more/attendance" exact>
                    <More.Attendance />
                </Route>
                <Route path="/more/my-time-records" exact>
                    {canUseAttendance(me) ? <More.MyTimeRecords /> : <Redirect to="/more" />}
                </Route>
                <Route path="*">
                    <Redirect to="/more" />
                </Route>
            </Switch>
        );
    }

    return(
        <Switch>
            <Route path="/more/" exact>
                <More.Single />
            </Route>
            <Route path="/more/check-in-point" exact>
                {canManageCheckInPoint(me) ? <More.CheckInPoint /> : <Redirect to="/more" />}
            </Route>
            <Route path="/more/attendance" exact>
                <More.Attendance />
            </Route>
            { permission().has({value: "view_damages"}) &&
                <Route path="/more/view-damages" exact>
                    <More.ViewDamages/>
                </Route>
            }
            <Route path="/more/halls-overview" exact>
                <More.HallsOverview />
            </Route>
            <Route path="/more/collect-graphics" exact>
                <More.CollectGraphics />
            </Route>
            <Route path="/more/my-time-records" exact>
                {canUseAttendance(me) ? <More.MyTimeRecords /> : <Redirect to="/more" />}
            </Route>
            <Route path="/more/expo-plan/" exact>
                <Pages.Halls.Collection />
            </Route>
            <Route path="/more/expo-plan/:id" exact>
                <Pages.Halls.Single />
            </Route>
            <Route path="/more/furnishing" exact>
                <Pages.More.Furnishing />
            </Route>
            <Route path="/more/documents" exact>
                <Pages.More.Documents />
            </Route>
            <Route path="/more/help-and-imprint" exact>
                <More.HelpImprint />
            </Route>
            <Route path="*" >
                <Pages.Page404 />
            </Route>
        </Switch>
    );
};

export default MoreRoutes;
